import { NavLink, Outlet } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Circle, Repeat2, Sparkles } from "lucide-react";

const TABS = [
  { to: "/health",         label: "Ring",     icon: Circle,    testId: "health-nav-today", end: true },
  { to: "/health/habits",  label: "Habits",   icon: Repeat2,   testId: "health-nav-habits" },
  { to: "/health/history", label: "Tapestry", icon: Sparkles,  testId: "health-nav-history" },
];

export default function HealthLayout() {
  return (
    <div className="animate-fade-in-up">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-2xl md:text-3xl font-medium text-surface-on tracking-tight">Health</h2>
          <p className="text-sm text-surface-onVariant mt-1">Rhythm, not streaks. How your day feels — not how it scores.</p>
        </div>
      </div>
      <div className="mb-6 inline-flex items-center gap-1 rounded-full bg-surface-container p-1">
        {TABS.map(({ to, label, icon: Icon, testId, end }) => (
          <NavLink
            key={to} to={to} end={end}
            data-testid={testId}
            className={({ isActive }) => cn(
              "inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ease-md",
              isActive ? "bg-primary text-primary-foreground" : "text-surface-on hover:bg-primary/8"
            )}
          >
            <Icon className="w-4 h-4" />
            {label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
